import React, { useCallback, useState } from "react";

// Lib
import { isEngLang } from "lib/helpers";
import { shallowEqual } from "react-redux";
import { getDriverInstance } from 'lib/driver';
import { messageNotEmptyValue } from "lib/thesaurus";
import { useAppDispatch, useAppSelector } from "lib/hooks/useDispatch";

// Constants
import { DEFAULT_REQUEST_CONFIG } from "pages/Thesaurus/Thesaurus";

// Actions
import { openModal } from 'reducers/modal';
import { showMessage } from "reducers/messages";
import * as actionsCreatorSearch from "pages/Search/reducer";
import * as actionsCreatorThesaurus from "pages/Thesaurus/reducer";

// Components
import Button from "components/UiKit/Button";
import DebounceInput from "components/UiKit/DebounceInput";

export const Bar: React.FC = () => {
  const drv = getDriverInstance();
  const dispatch = useAppDispatch();

  const {
    type,
    data,
    message,
    loadingSearchBio: loading
  } = useAppSelector(
    (store) => store.thesaurus,
    shallowEqual
  );
  const recentSearchList = useAppSelector(
    (store) => store.search.recentBioSearchList,
    shallowEqual
  );
  // const value = useAppSelector(
  //   (store) => store.search.bioSearchForm.value,
  //   shallowEqual
  // );
  // const disabled = useAppSelector(
  //   (store) => store.search.bioSearchForm.disabled,
  //   shallowEqual
  // );
  // handleChangeInputBioSearch,
    // handleChangeDisabledBioSearch,

  const [input, setInput] = useState("");
  const [disabled, setDisabled] = useState(true);

  const checkValueIsEngLang = (value: string) => {
    const isEng = isEngLang(value);
    setDisabled(isEng);
    // dispatch(actionsCreatorSearch.handleChangeDisabledBioSearch(isEng));

    if (!isEng) {
      dispatch(actionsCreatorThesaurus.handlerChangeMessage({
        type: "info",
        message: "Please use Latin letters only"
      }));
      return;
    }

    dispatch(actionsCreatorThesaurus.handlerChangeMessage({
      type: "info",
      message: ""
    }));
    return value;
  };

  const handlerSubmit = useCallback(() => {
    if (!input?.length) {
      dispatch(showMessage(messageNotEmptyValue));
      return;
    }

    dispatch(actionsCreatorThesaurus.handlerChangeInput(input));

    dispatch(actionsCreatorSearch.historyList({
      data: input || "",
      storeName: "recentBioSearchList",
      localStoreKey: "recentBioSearchList"
    }));

    dispatch(actionsCreatorSearch.handlerChangeIsSearch(true));
  }, [
    input
  ]);

  const onChange = useCallback((value: string) => {
    const val = checkValueIsEngLang(value);

    setInput(val || '');
    // dispatch(actionsCreatorSearch.handleChangeInputBioSearch(val));

    dispatch(actionsCreatorThesaurus.handlerChangeAutoExpand(true));
  }, []);

  const handlerClick = (value: string) => {
    setInput(value);
    dispatch(actionsCreatorSearch.handleChangeInputBioSearch(value));
    dispatch(actionsCreatorThesaurus.handlerChangeAutoExpand(true));
  };

  const handleKeyDown = useCallback((
    e: React.KeyboardEvent<HTMLInputElement>
  ): void | boolean => {
    if (e.key === "Enter") {
      if (!input?.length) {
        dispatch(showMessage(messageNotEmptyValue));
        return false;
      }

      e.preventDefault();
      dispatch(actionsCreatorThesaurus.handlerChangeInput(input));

      dispatch(actionsCreatorSearch.historyList({
        data: input || "",
        storeName: "recentBioSearchList",
        localStoreKey: "recentBioSearchList"
      }));
    }
  }, [
    input
  ]);

  const submitRefresh = () => {
    setInput('');
    // dispatch(actionsCreatorThesaurus.handlerChangeInput(''));
    dispatch(actionsCreatorThesaurus.getThesaurusById(DEFAULT_REQUEST_CONFIG));
    dispatch(actionsCreatorThesaurus.handleExpand([]));
    dispatch(actionsCreatorThesaurus.handlerChangeCheckedGtf([]));
    dispatch(actionsCreatorThesaurus.handlerUpdateTags([]));
  };

  const submitRefreshConfirm = () => {
    dispatch(openModal({
      type: 'confirm',
      actionSubmit: submitRefresh,
      text: 'Do you want refresh tree?',
    }));
  };

  const submitDisable = disabled && !!input;

  return (
    <div className="flex flex-ai-start flex-jc-between flex-ai-center-mobile flex-direction-column-mobile mb20">
      <DebounceInput
        value={input}
        uniqId="bio-search-debounce-input"

        isHiddenDropdown
        isLeftIcon
        isRightIcon
        minLength={3}
        suggest={data}
        message={message}
        loading={loading}
        typeMessage={type}
        onChange={onChange}
        debounceTimeout={300}
        onKeyDown={handleKeyDown}
        disabled={!!drv?.isActive()}
        leftIconAction={handlerSubmit}
        clickRecentItem={handlerClick}
        recentList={recentSearchList || []}
        rightIconAction={() => setInput("")}
        placeholder="Type here the target you need to find"
        styleInput={!!drv?.isActive() ? { pointerEvents: 'none' } : {}}
      />

      <div className="flex flex-ai-center flex-jc-between">
        <Button
          type="button"
          label="Search"
          variable="info"
          typePadding="middle"
          id="bio-search-submit"
          onPress={handlerSubmit}
          disabled={!submitDisable}
          className="search-screen__search-btn"
        />

        <Button
          isSvg
          type="button"
          variable="icon"
          className="ml10"
          icon="refreshIcon"
          typePadding="middle"
          title="Refresh tree"
          onPress={submitRefreshConfirm}
        />
      </div>
    </div>
  );
};

export default Bar;
